<table class="table table-sm table-hover table-striped">
  <thead>
  <tr>
    <th>Identification ID</th>
    <th>Expected Item</th>
    <th class="td-center">Identification Outcome</th>
    <th>Identified Item</th>
    <th *ngIf="isSuperuser">Match Percentage</th>
    <th>Station</th>
    <th>User ID</th>
    <th>Created</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let ir of identificationResults; index as i" #stockItemList
      [ngClass]="currentIdentificationId === ir.identificationId ? 'ae-select link-active' : 'link-active'"
      (click)="setIdentificationEvent.emit({id: ir.identificationId, index: i})"
  >
    <td>
      <a class="link-active" matTooltip="click to open FeaturePrint in new tab"
         target="_blank"
         [routerLink]="['/identification', this.dataset, ir.identificationId]"> {{ ir.identificationId }} </a>
    </td>
    <td matTooltip="click row for details">{{ ir.externalIdentifier  || 'N/A' | ellipsis:30 }}</td>
    <td class="td-center">
      <mat-icon *ngIf="ir.matchOutcome === matchOutcome.MATCH || ir.matchOutcome === matchOutcome.MATCHED_EXPECTED"
                color="primary" matTooltip="FeaturePrint matched the expected item.">
        check
      </mat-icon>
      <mat-icon *ngIf="ir.matchOutcome === matchOutcome.MATCHED_UNEXPECTED_STOCKITEM || ir.matchOutcome === matchOutcome.MATCHED_UNEXPECTED_FACET"
                class="mismatch" matTooltip="Requires review. FeaturePrint identified a different item than expected.">
        warning
      </mat-icon>
      <mat-icon *ngIf="ir.matchOutcome === matchOutcome.NO_MATCH"
                color="warn" matTooltip="FeaturePrint did not identify any item. The expected item may not have been FeaturePrinted.">
        close
      </mat-icon>
      <mat-icon *ngIf="!isValidMatchOutcome(ir.matchOutcome)"
                class="black-icon" matTooltip="Identification not evaluated.">
        help
      </mat-icon>
    </td>
    <td matTooltip="click row for details">{{ ir.bestMatchExternalIdentifier  || 'N/A' | ellipsis:30 }}</td>
    <td *ngIf="isSuperuser">{{ir.matchPercentage }}</td>
    <td matTooltip="click row for details">{{ ir.stationId }}</td>
    <td matTooltip="click row for details">{{ ir.author }}</td>
    <td matTooltip="click row for details">{{ ir.created | date: "yyyy-MM-dd HH:mm:ss" }}</td>
  </tr>
  </tbody>
</table>
